import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import ProposeConsiderApproveProjectWidget from '../../../widgets/proposeConsiderApproveProject/ProposeConsiderApproveProjectWidget'
import ProposeConsiderApproveProjectUploadWidget from '../../../widgets/proposeConsiderApproveProject/ProposeConsiderApproveProjectUploadWidget'
import Attorney from '../../../widgets/attorney/Attorney'
import {
  getProposeConsiderApproveProject,
  downloadRequestApproveFile,
} from '../../../redux/actions/proposeConsiderApproveProject'

import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { Message, Placeholder } from 'rsuite'
import PdfRenderWidgets from '../../../widgets/pdfWidgets/PdfRenderWidgets'
import ApproverDetailWidgets from '../../../widgets/ApproverDetail/ApproverDetailWidgets'
import { getPaymentCheck } from '../../../redux/actions/paymentCheck'
import AttachFilesGranteeContract from '../../../widgets/makeContract/AttachFilesGranteeContract'
import { Panel } from 'rsuite'
import {
  getGranteeProperty,
  downloadGranteeFileById,
  getGranteeAllFile,
  deleteGranteeFileById,
  validatedFilebyId,
} from '../../../redux/actions/granteeProperty'
import notification from '../../../utils/notification'
import { getAssetRequestManagementDetail } from '../../../redux/actions/assetRequestManagementDetail'
import AssetRequestManagementDetailWidgets from '../../../widgets/assetRequestManagementDetailWidgets/AssetRequestManagementDetailWidgets'
import { sessionRemoveItem } from '../../../utils/sessionHelpers'
import AIEvaluationResultWidget from '../../../widgets/aiEvaluation/AIEvaluationResultWidget'
import { getAiEvaluationResult } from '../../../redux/actions/aiEvaluation'

export default function ProposeConsiderApproveProject() {
  const { Paragraph } = Placeholder

  const [schema, setSchema] = useState()
  const [attachFilesSchema, setAttachFilesSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [isInvalidAttorneyPerson, setIsInvalidAttorneyPerson] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [enableForm, setEnableForm] = useState(false)
  const [budgetschema, setBudgetSchema] = useState()
  const [assetRequestSchema, setAssetRequestSchema] = useState()

  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isGranteeFileError, setIsGranteeFileError] = useState(false)

  const [verifyStatus, setVerifyStatus] = useState()

  const userCode = localStorage.getItem('thp_user_code')

  useEffect(() => {
    sessionRemoveItem('isViewOnly')
    // console.log('load ObjectiveGoal proposal', projectId)
    if (projectId) {
      handleGetSchema(projectId)
      handleGetBudgetSchema(projectId)
      handleGetGranteeProperty(projectId)
      handleGetVerifyStatus(projectId)
    }

    handleRequestAssetSchema()
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await getProposeConsiderApproveProject(proposalId)
      console.warn('schema ', _schema.forms)
      // _schema.forms.attachFiles = mockSchema
      // TO DO integrate with API
      // _schema.forms.contractSignType = mschema.forms.contractSignType
      // _schema.forms.uploadDocuments = mschema.forms.uploadDocuments
      setSchema(_schema)
      //setSchema(mockSchema)
    } catch (e) {
      console.log(e)
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleGetVerifyStatus = async (projectId) => {
    try {
      const response = await getAiEvaluationResult(projectId)

      if (response) {
        setVerifyStatus(response)
      }
    } catch (e) {}
  }

  const handleGetGranteeProperty = async (proposalId) => {
    try {
      const _schema = await getGranteeProperty(proposalId)
      // console.log('1234 ', _schema.forms.property)
      setAttachFilesSchema(_schema.forms.property)
    } catch (e) {
      setError({})
    }
  }

  const handleGetBudgetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await getPaymentCheck(proposalId)
      console.log('_schema', budgetschema)
      setBudgetSchema(_schema)
    } catch (e) {
      console.log(e)
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleRequestAssetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      //const id = bookingInfo.id ? bookingInfo.id : ''
      const _schema = await getAssetRequestManagementDetail('', 0, 0, projectId)
      setAssetRequestSchema(_schema.model)
    } catch (e) {
      console.log(e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetFile = async (id) => {
    startLoading()
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const response = await downloadRequestApproveFile(id)
      console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      setIsPdfError(true)
    }
    setIsLoadingPDF(false)
    doneLoading()
  }

  const handleDelete = async (id) => {
    startLoading()
    // setIsLoading(true)
    setIsDeleteError(false)
    try {
      console.log('call delete.')
      const status = await deleteGranteeFileById(projectId, id)
      console.log('status', status)
      if (status === 200) {
        let response = await getGranteeAllFile(projectId)
        console.log('resssss ', response)
        handleOnUploadSuccess()
        // setSchema(response.model.forms.forms)
        // setIsDeleteError(false)
      } else {
        setIsDeleteError(response.model.errorMessage || 'ไม่สำเร็จ')
      }
    } catch (e) {
      console.log('e', e)

      if (e?.response?.data) {
        setIsDeleteError(e.response.data.errorMessage)
      } else {
        setIsDeleteError('ไม่สำเร็จ')
      }
    }
    // setIsLoading(false)
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadGranteeFileById(projectId, fileObj.id)
      //  var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileObj.name)
      document.body.appendChild(link)
      link.click()
      setIsGranteeFileError()
    } catch (e) {
      setIsGranteeFileError('ดาวน์โหลดไม่สำเร็จ')
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadGranteeFileById(projectId, fileObj.id)
      //  var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.setAttribute('value', fileObj.name)
      document.body.appendChild(link)
      link.click()
      setIsGranteeFileError()
    } catch (e) {
      setIsGranteeFileError('แสดงไม่สำเร็จ')
    }
    doneLoading()
  }

  const handleOnUploadSuccess = async (res) => {
    console.log(res)
    projectId && handleGetGranteeProperty(projectId)
  }

  const handleOnValidateFile = async (rowData) => {
    startLoading()
    //setIsLoading(true)
    try {
      const response = await validatedFilebyId(projectId, rowData.id, !rowData.isValidated)
      if (response) {
        projectId && handleGetGranteeProperty(projectId)
      }
    } catch (e) {
      console.log('e', e)
      if (e?.response?.data) {
        notification.open('error', {
          title:
            e.response.data.errorMessage ||
            'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ',
        })
      } else {
        notification.open('error', {
          title: 'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ',
        })
      }
    }
    //setIsLoading(false)
    doneLoading()
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          <ProjectBasicInfo schema={schema.projectInfo} />

          <AIEvaluationResultWidget schema={verifyStatus} shaded showDetail={false} />
          <br />
          <Attorney
            showCommandButton={
              (!schema?.forms?.disabled || enableForm) && !schema?.forms?.isContractCenter
            }
            schema={schema?.forms?.attorney}
            updateIsInvalidAttorneyPerson={(isInvalid) => setIsInvalidAttorneyPerson(isInvalid)}
          />
          <br />

          {schema.forms?.uploadDocuments && (
            <>
              <ProposeConsiderApproveProjectUploadWidget
                showCommandButton={
                  (!schema?.forms?.disabled || enableForm) && !schema?.forms?.isContractCenter
                }
                schema={schema.forms?.uploadDocuments}
              />
              <br />
            </>
          )}

          {attachFilesSchema && (
            <Panel shaded header={attachFilesSchema.attachFiles.header} defaultExpanded collapsible>
              <AttachFilesGranteeContract
                onDelete={handleDelete}
                onDownload={onDownload}
                onPreview={onPreview}
                onUploadSuccess={(e) => handleOnUploadSuccess(e)}
                schema={attachFilesSchema}
                isEditErr={isEditErr}
                isUploadErr={isUploadErr}
                isDeleteError={isDeleteError}
                loading={isLoading}
                disabledForm={
                  (schema?.forms?.disabled && !enableForm) || schema?.forms?.isContractCenter
                }
                isStaff={true}
                onValidateFile={(rowData) => handleOnValidateFile(rowData)}
              />
            </Panel>
          )}

          <br />

          {assetRequestSchema && (
            <AssetRequestManagementDetailWidgets
              schema={assetRequestSchema}
              userRole={userCode}
              header={assetRequestSchema?.header}
              isProposalStep
            />
          )}

          <br />

          <ProposeConsiderApproveProjectWidget
            showCommandButton={
              (!schema?.forms?.disabled || enableForm) && !schema?.forms?.isContractCenter
            }
            schema={schema.forms}
            disabled={isInvalidAttorneyPerson}
            onSuccess={() => handleGetSchema(projectId)}
            onEnableForm={() => setEnableForm(!enableForm)}
            attachFilesSchema={attachFilesSchema}
            isConfirmEbudget={
              budgetschema?.forms?.budget?.isDisabled &&
              budgetschema?.forms?.budgetInstallmentPlan?.installment?.length > 0
                ? true
                : false
            }
            isApproveByContractCenter={schema?.forms?.isApproveByContractCenter}
            isContractCenter={schema?.forms?.isContractCenter}
          />

          <br />

          {schema.forms?.approverDetail?.approverList?.length > 0 && (
            <>
              <ApproverDetailWidgets
                dataList={schema.forms?.approverDetail?.approverList}
                header={schema.forms?.approverDetail?.title}
              />

              <br />
            </>
          )}

          {isPdfError ? (
            <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
          ) : (
            <PdfRenderWidgets
              header={'แบบขออนุมัติและจัดทำสัญญา'}
              file={previewPdf}
              isLoading={isLoadingPDF}
              fileName={'แบบขออนุมัติและจัดทำสัญญา'}
              onReload={() => {
                handleGetFile(projectId)
              }}
              loadingMessage={'กรุณารอสักครู่ ระบบกำลังสร้าง PDF แบบขออนุมัติและจัดทำสัญญา...'}
              firstExpandToReload={true}
            />
          )}
          <br />
        </SidebarProposal>
      )}
    </>
  )
}
